import * as React from 'react';
export const pricingPlanSvg = React.forwardRef(function pricingPlanSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.353 8.55c.292-.163.757-.158 1.039.01.282.168.275.437-.017.6l-4.25 2.373c-.629.35-1.627.348-2.25-.006L.706 9.157c-.289-.165-.293-.433-.008-.6.284-.167.75-.169 1.039-.005l4.17 2.37a.22.22 0 0 0 .196.001l4.25-2.374Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.353 5.837c.292-.162.757-.157 1.039.011.282.168.275.437-.017.6L7.125 8.82c-.629.35-1.627.348-2.25-.006L.706 6.445c-.289-.164-.293-.433-.008-.6.284-.167.75-.169 1.039-.005l4.17 2.37a.22.22 0 0 0 .196.001l4.25-2.374Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.863.557c.628-.362 1.645-.362 2.274 0l3.764 2.173c.628.363.628.95 0 1.313L7.137 6.216c-.628.363-1.646.363-2.274 0L1.099 4.043c-.628-.362-.628-.95 0-1.313L4.863.557Zm1.236.6a.221.221 0 0 0-.198 0L2.137 3.33c-.054.031-.054.082 0 .114l3.764 2.173a.222.222 0 0 0 .198 0l3.764-2.173c.054-.032.053-.083 0-.114L6.099 1.157Z',
    }),
  );
});
pricingPlanSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pricingPlan = {
  category: 'icon',
  colorable: true,
  name: 'pricingPlan',
  svg: pricingPlanSvg,
};
